module.exports = __webpack_public_path__ + "static/media/google-logo.c56819a5.svg";